import React from 'react';

const DocumentationSkeleton = () => {
  return (
    <div className="w-full mx-auto px-6 py-8 animate-pulse box-border">
      {/* Page title skeleton */}
      <div className="h-10 w-1/2 bg-slate-300 rounded mb-8" />

      {/* Section 1 */}
      <div className="mb-8">
        <div className="h-8 w-1/3 bg-slate-200 rounded mb-4" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-slate-300 rounded" />
          <div className="h-4 w-5/6 bg-slate-300 rounded" />
          <div className="h-4 w-4/6 bg-slate-300 rounded" />
        </div>
      </div>

      {/* Section 2 */}
      <div className="mb-8">
        <div className="h-8 w-2/5 bg-slate-200 rounded mb-4" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-slate-300 rounded" />
          <div className="h-4 w-4/5 bg-slate-300 rounded" />
        </div>
      </div>

      {/* Section 3 */}
      <div className="mb-8">
        <div className="h-8 w-1/4 bg-slate-200 rounded mb-4" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-slate-300 rounded" />
          <div className="h-4 w-3/4 bg-slate-300 rounded" />
          <div className="h-4 w-5/6 bg-slate-300 rounded" />
        </div>
      </div>

      {/* Section 4 */}
      <div className="mb-8">
        <div className="h-8 w-2/5 bg-slate-200 rounded mb-4" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-slate-300 rounded" />
          <div className="h-4 w-11/12 bg-slate-300 rounded" />
          <div className="h-4 w-3/5 bg-slate-300 rounded" />
        </div>
      </div>

      {/* Section 5 - Only visible on medium and large screens */}
      <div className="mb-8 max-md:hidden">
        <div className="h-8 w-1/3 bg-slate-200 rounded mb-4" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-slate-300 rounded" />
          <div className="h-4 w-2/3 bg-slate-300 rounded" />
        </div>
      </div>
    </div>
  );
};

export default DocumentationSkeleton;
